import React, { useState } from 'react';
import { updateCollection, deleteCollection } from '@utilities/auth';
import {
  buildFoodOrderSnapshot,
  logOrderEventAsync,
} from '@utilities/orderLogging';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Grid, Typography } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import moment from 'moment';

const InitialFormState = {
  billType: 'orders',
  orderId: '',
  createdAtDate: new Date()?.toISOString(),
};

const CollectionMap: any = {
  'orders': 'orders',
  'room-bills': 'room-bills',
}

function UpdateOrder() {
  const params = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ ...InitialFormState });
  const handleDateChange = (event: any, name: string) => {
    setFormData({ ...formData, [name]: event?.toISOString() });
  };

  const _handleChange = (event: any) => {
    const { name, value } = event.target;
    if (name === 'billType') {
      setFormData({ ...formData, [name]: value, "billType": value });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleUpdateOrder = () => {
    if (params?.orderId && formData?.createdAtDate && formData?.billType) {
      const orderId = params.orderId;
      const restaurantId = params?.restaurantId || '';
      const nextCreatedAt = moment(formData?.createdAtDate).utc().valueOf();
      const previous = buildFoodOrderSnapshot({ createdAt: null });
      const next = buildFoodOrderSnapshot({ createdAt: nextCreatedAt });
      const clientRequestId =
        typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
          ? crypto.randomUUID()
          : `food-upd-legacy-${Date.now()}`;

      updateCollection(CollectionMap['orders'], orderId, 'createdAt', nextCreatedAt).then((ok) => {
        logOrderEventAsync({
          restaurantId: String(restaurantId || 'unknown'),
          orderId,
          collectionName: 'orders',
          orderKind: 'food',
          action: 'update',
          status: ok ? 'success' : 'failed',
          source: 'legacy-update-order',
          errorMessage: ok ? null : 'Failed to update order bill date',
          previous,
          next,
          snapshot: next,
          clientRequestId,
        });
        if (ok) {
          navigate(`/admin/${params?.restaurantId}/orders`);
        }
      });
    }
  };

  const handleDeleteOrder = () => {
    if (!params?.orderId) return;
    const orderId = params.orderId;
    const restaurantId = params?.restaurantId || '';
    const clientRequestId =
      typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : `food-del-legacy-${Date.now()}`;

    deleteCollection(CollectionMap['orders'], orderId).then((ok) => {
      logOrderEventAsync({
        restaurantId: String(restaurantId || 'unknown'),
        orderId,
        collectionName: 'orders',
        orderKind: 'food',
        action: 'delete',
        status: ok ? 'success' : 'failed',
        source: 'legacy-update-order',
        errorMessage: ok ? null : 'Firestore delete failed or order id missing',
        snapshot: { uoId: null, orderSeqNo: null },
        clientRequestId,
      });
      if (ok) {
        navigate(`/admin/${params?.restaurantId}/orders`);
      }
    });
  };

  return (
    <div>
      <Grid container spacing={2} sx={{ padding: '0 30px' }}>
        <Grid item xs={12}>
          <Typography style={{ backgroundColor: 'var(--secondary)', color: '#fff', fontWeight: 'bold', padding: '0 6px' }}>Update Order - Bill Date</Typography>
        </Grid>
        {/* <Grid item sm={3} xs={4}>
          <FormControl fullWidth>
            <InputLabel>Bill Type</InputLabel>
            <Select
              value={formData?.billType}
              onChange={handleChange}
              name="billType"
            >
              <MenuItem key={'orders'} value={'orders'}>Orders</MenuItem>
              <MenuItem key={'room-bills'} value={'room-bills'}>Room Bills</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item sm={6} xs={8}>
          <TextField
            fullWidth
            label="Order ID"
            name="orderId"
            value={formData?.orderId}
            onChange={handleChange}
          />
        </Grid> */}
        <Grid item xs={12}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer
              components={[
                'DatePicker',
                'TimePicker',
                'DateTimePicker',
                'DateRangePicker',
              ]}
            >

              <DemoItem>
                <DateTimePicker value={dayjs(formData?.createdAtDate)} onChange={(e) => handleDateChange(e, 'createdAtDate')} />
              </DemoItem>
            </DemoContainer>
          </LocalizationProvider>
        </Grid>
        {/* Code to delete order */}
        <Grid item xs={6}>
          <Button fullWidth onClick={handleDeleteOrder} variant="outlined" color="error">Delete Order</Button>
        </Grid>
        <Grid item xs={6}>
          <Button fullWidth onClick={handleUpdateOrder} variant="contained" color="primary">Update Date</Button>
        </Grid>
      </Grid>
    </div>
  );
}

export default UpdateOrder;
